module.exports = __webpack_public_path__ + "static/media/HU.85015780.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/HU.svg
// module id = 2169
// module chunks = 7